import { render, staticRenderFns } from "./TableBlueClubTransfers.vue?vue&type=template&id=11d4559a&"
import script from "./TableBlueClubTransfers.vue?vue&type=script&lang=js&"
export * from "./TableBlueClubTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports